<template>
  <div class="ex-detail" v-loading="loading">
    <div class="company-info">
      <button type="button" class="data-btn" @click="addExpertBtn">
        <img src="@/assets/images/a-jiluwendang 2@2x.png" class="icon-jiluwendang" alt="">
        生成专家报告
      </button>
      <div class="head-row">
        <img
          v-if="ruleForm.expertPicture"
          :src="prodUrl + ruleForm.expertPicture"
          class="company_pic"
          alt=""
        >
        <GsMediaPh v-else class="company_pic" label="暂无图片" />
        <div class="company-name">
          <div class="company-title">{{ ruleForm.name || '专家详情' }}</div>
          <div class="company-code">
            <span>职位：</span>
            <GsVal :value="ruleForm.position" empty="暂未公开" />
          </div>
          <div class="tag-row">
            <span v-if="ruleForm.enterpriseName" class="info-btn">{{ ruleForm.enterpriseName }}</span>
            <span v-for="(tag, i) in specialtyTags" :key="i" class="info-btn">{{ tag }}</span>
            <span v-if="ruleForm.areaName" class="info-last">{{ ruleForm.areaName }}</span>
          </div>
        </div>
      </div>
      <div class="bg intro-box">
        <div class="intro-label">专家介绍</div>
        <div class="intro-row">
          <div v-if="ruleForm.expertProfile" :class="{ 'ellipsis-one': showBtn }">{{ ruleForm.expertProfile }}</div>
          <div v-else class="gs-text-ph">专家介绍暂未公开，后续将补充研究方向、职业履历与公开观点。</div>
          <button
            v-if="ruleForm.expertProfile && ruleForm.expertProfile.length > 48"
            type="button"
            class="detail-btn"
            @click="showBtn = !showBtn"
          >
            {{ showBtn ? '详情 ▼' : '收起 ▲' }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-card">
      <TitleTool title="基本信息" />
      <div class="detail-form bg">
        <el-row>
          <el-col :span="8">
            <div class="kv">
              <span>组织 / 公司</span>
              <EnterpriseLink v-if="enterpriseId" :id="enterpriseId" :name="ruleForm.enterpriseName" />
              <GsVal v-else :value="ruleForm.enterpriseName" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="kv"><span>职位</span><GsVal :value="ruleForm.position" /></div>
          </el-col>
          <el-col :span="8">
            <div class="kv"><span>专业领域</span><GsVal :value="specialtyText" /></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="kv"><span>详细地址</span><GsVal :value="ruleForm.officeAddress" /></div>
          </el-col>
          <el-col :span="8">
            <div class="kv"><span>办公地区</span><GsVal :value="ruleForm.areaName" /></div>
          </el-col>
          <el-col :span="8">
            <div class="kv"><span>专家名句</span><GsVal :value="ruleForm.expertSentence" /></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="kv"><span>发布期刊名称</span><GsVal :value="ruleForm.journal" /></div>
          </el-col>
          <el-col :span="8">
            <div class="kv"><span>简历介绍</span>
              <a v-if="ruleForm.resumeFile || ruleForm.resumeAttachment" :href="resumeUrl" target="_blank" rel="noopener" class="blue-text">查看简历</a>
              <GsVal v-else :value="''" empty="暂未上传" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="kv"><span>专家介绍</span><GsVal :value="ruleForm.expertProfile" /></div>
          </el-col>
        </el-row>
      </div>

      <div class="mt20">
        <TitleTool title="公开观点" />
        <div class="detail-form bg">
          <div v-if="ruleForm.expertSentence" class="product-intro">{{ ruleForm.expertSentence }}</div>
          <div v-else class="section-empty">公开观点暂未收录</div>
        </div>
      </div>

      <div v-if="articleTotal" class="mt20">
        <TitleTool title="公开发表" />
        <div class="detail-form bg">
          <a
            v-for="item in dataList"
            :key="item.id || item.url"
            class="article-row"
            :href="item.url || 'javascript:void(0)'"
            :target="item.url ? '_blank' : null"
            rel="noopener noreferrer"
          >
            <strong>{{ item.title || item.name || '未命名文章' }}</strong>
            <span>{{ transFormEnum(mediaPlatformList, item.mediaPlatform) || item.url || '' }}</span>
          </a>
          <div v-if="!dataList.length" class="section-empty">暂无公开发表</div>
          <div class="table-pagination">
            <GsPagination
              :current-page="articlePage"
              :page-size="articlePageSize"
              :total="articleTotal"
              @current-change="handleArticlePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addExpertInfoDetail, articleInfoList } from '@/api/api.js'
import { enumType } from '@/utils/enum.js'
import { getDataType } from '@/api/Layout/index.js'
import { routeId } from '@/router/paths'
import GsMediaPh from '@/components/GsMediaPh/index.vue'
import GsVal from '@/components/GsVal/index.vue'
import GsPagination from '@/components/GsPagination/index.vue'
import EnterpriseLink from '@/components/EnterpriseLink/index.vue'
import requset from '@/utils/request.js'
export default {
  name: 'InterViewDetail',
  components: { GsMediaPh, GsVal, GsPagination, EnterpriseLink },
  data() {
    return {
      loading: false,
      title: (this.$route.meta && this.$route.meta.title) || '',
      prodUrl: 'https://shujuzichan.com/xwzx',
      ruleForm: {},
      labelList: [],
      dataList: [],
      articleTotal: 0,
      articlePage: 1,
      articlePageSize: 10,
      mediaPlatformList: [],
      /** 企业中心轴：按企业名称反查企业 id，用于跳到企业详情 */
      enterpriseId: '',
      showBtn: true
    }
  },
  computed: {
    specialtyText() {
      return this.transFormEnum(this.labelList, this.ruleForm.specialtyDomain)
    },
    specialtyTags() {
      return String(this.specialtyText || '').split('、').map((s) => s.trim()).filter(Boolean)
    },
    transFormEnum() {
      return function (enumList, value, multi) {
        if (!value) return ''
        let valObj = []
        try {
          valObj = multi ? JSON.parse(value) : String(value).split(',').map((item) => item.trim())
        } catch (e) {
          valObj = String(value).split(',').map((item) => item.trim())
        }
        const labels = []
        ;(enumList || []).forEach((item) => {
          valObj.forEach((itemObj) => {
            if (String(itemObj) === String(item.value)) labels.push(item.label)
          })
        })
        return labels.join('、')
      }
    }
  },
  watch: {
    '$route.params.id'() {
      this.articlePage = 1
      this.addExpertInfo()
      this.articleInfo()
    }
  },
  created() {
    this.getData('sys_expert_specialty_domain')
    this.getData('sys_media_platform')
    this.addExpertInfo()
    this.articleInfo()
  },
  methods: {
    /** 专家的企业字段是名称字符串，这里按名称反查一次企业 id，能查到就渲染成企业链接 */
    async resolveEnterprise(name) {
      const keyword = String(name || '').trim()
      this.enterpriseId = ''
      if (!keyword) return
      try {
        const res = await requset({
          url: '/xwzx/enterprise/info/getEnterpriseNameInfoList',
          method: 'get',
          params: { pageNum: 1, pageSize: 10, enterpriseName: keyword },
        })
        const list = (res && res.rows) || []
        const hit = list.find((row) => String(row.label || '') === keyword) || list[0]
        if (hit && hit.value != null) this.enterpriseId = hit.value
      } catch (e) {
        this.enterpriseId = ''
      }
    },
    async getData(type) {
      try {
        const res = await getDataType(type)
        if (res && res.data && res.data.length > 0) {
          if (type === 'sys_expert_specialty_domain') this.labelList = enumType(res.data)
          if (type === 'sys_media_platform') this.mediaPlatformList = enumType(res.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    addExpertInfo() {
      const id = routeId(this.$route, 'id', 'Id')
      if (!id) return
      this.loading = true
      addExpertInfoDetail(id).then((response) => {
        this.ruleForm = (response && response.data) || {}
        this.loading = false
        this.resolveEnterprise(this.ruleForm.enterpriseName)
      }).catch(() => {
        this.loading = false
      })
    },
    articleInfo() {
      const id = routeId(this.$route, 'id', 'Id')
      if (!id) return
      articleInfoList({
        userId: id,
        pageNum: this.articlePage,
        pageSize: this.articlePageSize
      }).then((response) => {
        this.dataList = (response && response.rows) || []
        this.articleTotal = Number((response && response.total) || this.dataList.length) || 0
      }).catch(() => {
        this.dataList = []
        this.articleTotal = 0
      })
    },
    handleArticlePage(page) {
      this.articlePage = page
      this.articleInfo()
    },
    addExpertBtn() {}
  }
}
</script>
<style lang="css" scoped>
.ex-detail {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 0 40px;
  color: #1d2b44;
}
.company-info {
  position: relative;
  background: linear-gradient(180deg, #FFFFFF 0%, #F6F9FF 100%);
  border-radius: 8px;
  padding: 18px 18px 12px;
  margin-bottom: 16px;
}
.head-row {
  display: flex;
  align-items: center;
  min-width: 0;
  padding-right: 180px;
}
.company_pic {
  width: 106px;
  height: 106px;
  border-radius: 10px;
  margin-right: 20px;
  overflow: hidden;
  object-fit: cover;
  flex: 0 0 auto;
  background: #E8F1FF;
}
.company-name { min-width: 0; flex: 1; }
.company-title {
  font-size: 28px;
  font-weight: 800;
  color: #111824;
  line-height: 36px;
  margin-bottom: 8px;
}
.company-code {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 15px;
  color: #333;
  margin-bottom: 10px;
}
.tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.info-btn,
.info-last {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 16px;
}
.info-btn {
  background: #D6E5FE;
  color: #0165FF;
}
.info-last {
  background: #E2E2E2;
  color: #333;
}
.data-btn {
  position: absolute;
  right: 16px;
  top: 16px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: #E8F2FF;
  border-radius: 8px;
  color: #0165FF;
  font-size: 16px;
  font-weight: 700;
  padding: 6px 12px;
  cursor: pointer;
  font-family: inherit;
}
.icon-jiluwendang {
  width: 22px;
  height: 24px;
}
.intro-box {
  margin-top: 12px;
  padding: 12px 14px;
}
.intro-label {
  font-size: 14px;
  color: #5B6B82;
  margin-bottom: 6px;
}
.intro-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
}
.intro-row > div:first-child {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  line-height: 24px;
  color: #111824;
}
.gs-text-ph {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #F4F8FF 0%, #FFFFFF 100%);
  border: 1px dashed #C5D8F7;
  color: #7B8BA3;
  font-size: 13px;
  line-height: 22px;
}
.detail-btn {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: #0165FF;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  padding: 0;
}
.bg { background: #fff; border-radius: 8px; }
.form-card {
  background-color: rgba(75, 145, 255, 0.07);
  border-radius: 8px;
  padding: 16px 12px 20px;
}
.detail-form { padding: 8px 4px 4px; }
.kv {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 4px 12px;
  font-size: 15px;
}
.kv span:first-child {
  flex: 0 0 88px;
  color: #5B6B82;
}
.detail-form .el-col {
  border-right: 1px solid rgba(118, 118, 118, 0.13);
}
.detail-form .el-row .el-col:last-child {
  border-right: none;
}
.mt20 { margin-top: 20px; }
.product-intro {
  padding: 8px 12px;
  color: #111824;
  font-size: 14px;
  line-height: 24px;
}
.section-empty {
  min-height: 48px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: #6B7789;
  font-size: 14px;
}
.article-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  color: #111824;
  text-decoration: none;
  border-top: 1px solid #EEF3F8;
}
.article-row:first-child { border-top: 0; }
.article-row span { color: #7B889C; font-size: 13px; }
.table-pagination {
  margin-top: 12px;
}
@media (max-width: 960px) {
  .head-row {
    flex-direction: column;
    align-items: flex-start;
    padding-right: 0;
    padding-top: 44px;
  }
  .company_pic { margin: 0 0 12px; }
  .company-title { font-size: 22px; line-height: 28px; }
  .data-btn { font-size: 14px; padding: 4px 8px; }
  .detail-form .el-col { border-right: 0; }
  .kv { padding: 8px 12px; }
}
</style>
